
import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Container, Card, Button, InputGroup, Tooltip, OverlayTrigger } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';
import EditFeeWaiverModal from './EditFeeWaiverModal';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';

const FeeWaiver = () => {

  const [isEditable, setIsEditable] = useState(false);
  const [budgetList, setBudgetList] = useState([]);
  const [subBudgetList, setSubBudgetList] = useState([]);
  const [ddlFeeDescs, setDdlFeeDescs] = useState([]);
  const [errors, setErrors] = useState({});
  const [rowErrors, setRowErrors] = useState({});
  const [showsearchModal, setShowSearchModal] = useState(false);

  // Header State
  const [headerData, setHeaderData] = useState({
    fw_id: '',
    fw_desc: '',
    fw_type: '',
    status: 'A',
    fw_catg: '',
    mthly_inst: 'I',
    bgt_id: '',
    bgt_name: '',
    sub_bgt_id: '',
    sub_bgt_name: '',
    percent_amt: 'P',
  });

  // Child Table Data
  const [childRows, setChildRows] = useState([
    {
      fee_code: '',
      fee_desc: '',
      fw_perc: '',
      fw_inst1: '',
      fw_inst2: '',
      fw_inst3: '',
      fw_inst4: '',
      fw_inst5: '',
      fw_inst6: '',
    }
  ]);

  const handleHeaderChange = (e) => {

    const { name, value } = e.target;
    setHeaderData(prev => ({ ...prev, [name]: value }));

    setErrors(prev => ({ ...prev,  [name]: "" }));

  };

  const handleBudgetChange = async (selectedOption) => {

    try {

      setSubBudgetList([]);

      setHeaderData(prev => ({
        ...prev,
        sub_bgt_id: "",
        sub_bgt_name: ""
      }));

      setHeaderData(prev => ({
        ...prev,
        bgt_id: selectedOption ? selectedOption.value : "",
        bgt_name: selectedOption ? selectedOption.label : ""
      }));

      if (selectedOption.value) {
        const res = await axios.get(`${BASE_URL}/api/ddl_sub_budget_master`, { params: { p_Bdgt_Id: selectedOption.value } } );
        setSubBudgetList(res.data);
      }

    } catch (e) {
      toast.error('Unable to retrieve Budget data.');
    }

  };

  const handleSubBudgetChange = (selectedOption) => {

    try {

      setHeaderData(prev => ({
        ...prev,
        sub_bgt_id: selectedOption ? selectedOption.value : "",
        sub_bgt_name: selectedOption ? selectedOption.label : ""
      }));

    } catch (e) {
      toast.error('Unable to retrieve Sub-Budget data.');
    }

  };

  const handleChildChange = (index, e) => {

    const { name, value } = e.target;
    const updatedRows = [...childRows];

    updatedRows[index][name] = value;

    setChildRows(updatedRows);

    setRowErrors({});

  };

  // const handleBlurFWPerc = (index, e) => {

  //   const { name, value } = e.target;
  //   const updatedRows = [...childRows];

  //   updatedRows[index]['fw_inst1'] = value;
  //   updatedRows[index]['fw_inst2'] = value;
  //   updatedRows[index]['fw_inst3'] = value;
  //   updatedRows[index]['fw_inst4'] = value;
  //   updatedRows[index]['fw_inst5'] = value;
  //   updatedRows[index]['fw_inst6'] = value;

  //   setChildRows(updatedRows);

  // };

  useEffect(() => {

    const fetchLists = async () => {

      try {

        const result = await axios.get(`${BASE_URL}/api/ddl_fees_desc`);
        setDdlFeeDescs(result.data);

        const budgetresult = await axios.get(`${BASE_URL}/api/ddl_budget_master`);
        setBudgetList(budgetresult.data);

      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }

    };

    fetchLists();

  }, []);

  const addRow = () => {
    
    setChildRows([...childRows, { fee_code: '', fee_desc: '', fw_perc: '', fw_inst1: '', fw_inst2: '',
                                  fw_inst3: '', fw_inst4: '', fw_inst5: '', fw_inst6: '' }]);

  };

  const removeRow = (index) => {

    const updatedRows = [...childRows];
    updatedRows.splice(index, 1);
    setChildRows(updatedRows);

  };

  const resetPage = () => {

    setHeaderData({ fw_id: '', fw_desc: '', fw_type: '', status: 'A', fw_catg: '', mthly_inst: 'I', 
                    bgt_id: '', bgt_name: '', sub_bgt_id: '', sub_bgt_name: '', percent_amt: 'P' });

    setChildRows([ {
        fee_code: '',
        fee_desc: '',
        fw_perc: '',
        fw_inst1: '',
        fw_inst2: '',
        fw_inst3: '',
        fw_inst4: '',
        fw_inst5: '',
        fw_inst6: '' } ]);

    setErrors({});

  };

  const handleNew = () => {

    setIsEditable(true);
    resetPage();

  };

  const handleSave = async () => {

    const newErrors = {};

    if (!headerData.fw_desc || headerData.fw_desc === '') {
      newErrors.fw_desc = 'Error';
      toast.error('Please enter Fee Waiver Description.')
    } else if (!headerData.fw_type || headerData.fw_type === '') {
      newErrors.fw_type = 'Error';
      toast.error('Please select Waiver Type.')
    } else if (!headerData.fw_catg || headerData.fw_catg === '') {
      newErrors.fw_catg = 'Error';
      toast.error('Please select Waiver Category.')
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      const firstErrorKey = Object.keys(newErrors)[0];
      if (firstErrorKey) {
        const el = document.getElementsByName(firstErrorKey)[0];
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          el.focus();
        }
      }
      return;
    }

    /// Child Table Validation

    const errors = {};

    for (let i = 0; i < childRows.length; i++) {

      const row = childRows[i];

      // Fee Code Validation
      if (!row.fee_code || row.fee_code === '') {
        errors[i] = {
          field: 'fee_code'
        };
        setRowErrors(errors);
        document.getElementById(`fee_code_${i}`)?.focus();
        toast.error(`Please select Fee Description at Row # ${i + 1}`);
        return;
      } else if (headerData.mthly_inst === 'I' && 
                 (!row.fw_inst1 || row.fw_inst1 === 0) && (!row.fw_inst2 || row.fw_inst2 === 0) &&
                 (!row.fw_inst3 || row.fw_inst3 === 0) && (!row.fw_inst4 || row.fw_inst4 === 0) &&
                 (!row.fw_inst5 || row.fw_inst5 === 0) && (!row.fw_inst6 || row.fw_inst6 === 0)) {
        errors[i] = { field: ['fw_inst1', 'fw_inst2', 'fw_inst3', 'fw_inst4', 'fw_inst5', 'fw_inst6'] };
        setRowErrors(errors);
        document.getElementById(`fw_inst1_${i}`)?.focus();
        toast.error(`Please enter Fee Waiver % at least for one Installment at Row # ${i + 1}`);
        return;
      } else if (headerData.mthly_inst === 'M' && !row.fw_perc) {
        errors[i] = {
          field: 'fw_perc'
        };
        setRowErrors(errors);
        document.getElementById(`fw_perc_${i}`)?.focus();
        toast.error(`Please select Fee Waiver % at Row # ${i + 1}`);
        return;
      } else if (headerData.mthly_inst === 'I' && headerData.percent_amt === 'P' && row.fw_inst1 && row.fw_inst1 > 100) {
        errors[i] = {
          field: 'fw_inst1'
        };
        setRowErrors(errors);
        document.getElementById(`fw_inst1_${i}`)?.focus();
        toast.error(`Installment-1 Waiver % is more than 100 at Row # ${i + 1}`);
        return;
      } else if (headerData.mthly_inst === 'I' && headerData.percent_amt === 'P' && row.fw_inst2 && row.fw_inst2 > 100) {
        errors[i] = {
          field: 'fw_inst2'
        };
        setRowErrors(errors);
        document.getElementById(`fw_inst2_${i}`)?.focus();
        toast.error(`Installment-2 Waiver % is more than 100 at Row # ${i + 1}`);
        return;
      } else if (headerData.mthly_inst === 'I' && headerData.percent_amt === 'P' && row.fw_inst3 && row.fw_inst3 > 100) {
        errors[i] = {
          field: 'fw_inst3'
        };
        setRowErrors(errors);
        document.getElementById(`fw_inst3_${i}`)?.focus();
        toast.error(`Installment-3 Waiver % is more than 100 at Row # ${i + 1}`);
        return;
      } else if (headerData.mthly_inst === 'I' && headerData.percent_amt === 'P' && row.fw_inst4 && row.fw_inst4 > 100) {
        errors[i] = {
          field: 'fw_inst4'
        };
        setRowErrors(errors);
        document.getElementById(`fw_inst1_${i}`)?.focus();
        toast.error(`Installment-4 Waiver % is more than 100 at Row # ${i + 1}`);
        return;
      } else if (headerData.mthly_inst === 'I' && headerData.percent_amt === 'P' && row.fw_inst5 && row.fw_inst5 > 100) {
        errors[i] = {
          field: 'fw_inst5'
        };
        setRowErrors(errors);
        document.getElementById(`fw_inst5_${i}`)?.focus();
        toast.error(`Installment-5 Waiver % is more than 100 at Row # ${i + 1}`);
        return;
      } else if (headerData.mthly_inst === 'I' && headerData.percent_amt === 'P' && row.fw_inst6 && row.fw_inst6 > 100) {
        errors[i] = {
          field: 'fw_inst6'
        };
        setRowErrors(errors);
        document.getElementById(`fw_inst6_${i}`)?.focus();
        toast.error(`Installment-6 Waiver % is more than 100 at Row # ${i + 1}`);
        return;
      } else if (headerData.mthly_inst === 'M' && headerData.percent_amt === 'P' && row.fw_perc && row.fw_perc > 100) {
        errors[i] = {
          field: 'fw_perc'
        };
        setRowErrors(errors);
        document.getElementById(`fw_perc_${i}`)?.focus();
        toast.error(`Fee Waiver % is more than 100 at Row # ${i + 1}`);
        return;
      }

    }
    
    /// duplicate validation
    const feeCodeSet = new Set();

    for (let i = 0; i < childRows.length; i++) {

      const feeCode = childRows[i].fee_code;

      if (feeCodeSet.has(feeCode)) {
        errors[i] = {
          field: 'fee_code'
        };
        setRowErrors(errors);
        document.getElementById(`fee_code_${i}`)?.focus();
        toast.error(`Duplicate Fee Code at Row # ${i + 1}`);
        return;
      }

      feeCodeSet.add(feeCode);
    }

    // clear errors if validation passed
    setRowErrors({});

    const isConfirmed = window.confirm("Sure you want to Save the record ?");

    if (!isConfirmed) return;

    const structdata = {
      header: headerData,
      details: childRows,
    };

    const response = await axios.post(`${BASE_URL}/api/save_feeWaiverMast`, structdata);

    if (response.data.message === '1') {
        setIsEditable(false);
        resetPage();
        toast.success('Data saved successfully.');
    }

  };

  const handleClear = () => {
    if (window.confirm("Clear all data?")) {
      resetPage();
      setIsEditable(false);
    }
  };

  const handleFeesCodeChange = (index, selectedOption) => {

    const updated = [...childRows];
    updated[index].fee_code = selectedOption ? selectedOption.value : "";
    updated[index].fee_desc = selectedOption ? selectedOption.label : "";
    setChildRows(updated);

    setRowErrors({});

  };

  const handleSelectedRow = async (selRow) => {

    setShowSearchModal(false);

    const response = await axios.get(`${BASE_URL}/api/get_fees_waiver_ById`, { params: { p_FW_Id: selRow.fw_id } });

    headerData.fw_id = selRow.fw_id;
    headerData.fw_desc = response.data[0].fw_desc;
    headerData.fw_type = response.data[0].fw_type;
    headerData.fw_catg = response.data[0].fw_catg;
    headerData.status = response.data[0].status;
    headerData.mthly_inst = response.data[0].mthly_inst;
    headerData.bgt_id = response.data[0].bgt_id;
    headerData.percent_amt = response.data[0].perc_amt;

    if (response.data[0].bgt_id) {
      const res = await axios.get(`${BASE_URL}/api/ddl_sub_budget_master`, { params: { p_Bdgt_Id: response.data[0].bgt_id } });
      setSubBudgetList(res.data);
      headerData.sub_bgt_id = response.data[0].sub_bgt_id;
    }

    setChildRows(response.data);

    setIsEditable(true);

  };

  const budgetOptions = budgetList.map(sb => ({
    value: sb.bgt_id,
    label: sb.bgt_name
  }));

  const subBudgetOptions = subBudgetList.map(sb => ({
    value: sb.sub_bgt_id,
    label: sb.sub_bgt_name
  }));

  const feesDescOptions = ddlFeeDescs.map(code => ({
    value: String(code.fee_code),
    label: code.fee_desc
  })) || [];


  return (
    <Container fluid className="p-3">
      <Card className="mb-4 p-3">

        <Row className="mb-2">

          <Col md={8}>
            <InputGroup>
              <InputGroup.Text style={{ width: "160px" }}>
                Waiver Description <span style={{ color: "red" }}>*</span>
              </InputGroup.Text>
              <input type="text" style={{ textAlign: 'left' }} name="fw_desc"
                className={`form-control ${errors.fw_desc ? "is-invalid" : ""}`}
                value={headerData.fw_desc} disabled={!isEditable} onChange={handleHeaderChange} />
            </InputGroup>
          </Col>


          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "150px" }}>
                Waiver Type<span style={{ color: "red" }}>*</span>
              </InputGroup.Text>
              <select name="fw_type" value={headerData.fw_type}
                 className={`form-select ${errors.fw_type ? "is-invalid" : ""}`}
                disabled={!isEditable} onChange={handleHeaderChange} >
                <option value="">-- Select Section  --</option>
                <option value="A">Annually</option>
                <option value="P">Permanent</option>
              </select>
            </InputGroup>
          </Col>
        </Row>

        <Row className="mb-2">

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "160px" }}>
                Status
              </InputGroup.Text>
              <select className="form-select" name="status" value={headerData.status}
                disabled={!isEditable} onChange={handleHeaderChange} >
                <option value="A">Active</option>
                <option value="I">Inactive</option>
              </select>
            </InputGroup>
          </Col>

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "100px" }}>
                Category<span style={{ color: "red" }}>*</span>
              </InputGroup.Text>
              <select name="fw_catg" value={headerData.fw_catg}
                className={`form-select ${errors.fw_catg ? "is-invalid" : ""}`}
                disabled={!isEditable} onChange={handleHeaderChange} >
                <option value="">-- Select Category --</option>
                <option value="STAFF">Staff Child</option>
                <option value="ECOWK">Economically Weak</option>
                <option value="TCHLD">Third Child</option>
                <option value="NEBOR">Neighbour</option>
                <option value="ORPHN">Orphan</option>
                <option value="OTHER">Others</option>

              </select>
            </InputGroup>
          </Col>

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "150px" }}> Fee Type 
                {/* <span style={{ color: "red" }}>*</span> */}
              </InputGroup.Text>
              <select
                className="form-select"
                name="mthly_inst"
                value={headerData.mthly_inst}
                disabled={!isEditable}
              // onChange={handleChange}
              >
                <option value="I">Installments</option>
                <option value="M">Monthly</option>
              </select>
            </InputGroup>
          </Col>

        </Row>

        <Row className="mb-3">

          <Col md={6}>

            <InputGroup>
              <InputGroup.Text style={{ width: "100px" }}> Budget
              </InputGroup.Text>

              <div style={{ flex: 1 }}>
                <Select name="gr_no" isDisabled={!isEditable}
                  styles={{ singleValue: (provided) => ({ ...provided, }), }}
                  options={budgetOptions}
                  value={budgetOptions.find(option => String(option.value) === String(headerData.bgt_id)) || null}
                  onChange={handleBudgetChange} placeholder="Search Budget Name ..." />
              </div>

            </InputGroup>
          </Col>

          <Col md={6}>
            <InputGroup>
              <InputGroup.Text style={{ width: "110px" }}> Sub-Budget
              </InputGroup.Text>

              <div style={{ flex: 1 }}>
                <Select name="gr_no" isDisabled={!isEditable}
                  styles={{ singleValue: (provided) => ({ ...provided, }), }}
                  options={subBudgetOptions}
                  value={subBudgetOptions.find(option => String(option.value) === String(headerData.sub_bgt_id)) || null}
                  onChange={handleSubBudgetChange} placeholder="Search Sub-Budget Name ..." />
              </div>
              
            </InputGroup>

          </Col>

        </Row>

        <Row>

          <Col>

            {/* Waiver Type */}

            <div className="d-flex align-items-center gap-3">

              <span style={{ fontWeight: "bold" }}> Percent / Fixed Amount: </span>

              <div className="form-check form-check-inline mb-0">
                <input className="form-check-input" type="radio" name="percent_amt" id="percent_amt"
                  value="P" checked={headerData.percent_amt === "P"} onChange={handleHeaderChange}
                  disabled={!isEditable} />

                <label className="form-check-label" htmlFor="waiverPercent" > Percent </label>
              </div>

              <div className="form-check form-check-inline mb-0">
                <input className="form-check-input" type="radio" name="percent_amt" id="percent_amt"
                  value="FA" checked={headerData.percent_amt === "FA"} onChange={handleHeaderChange}
                  disabled={!isEditable} />

                <label className="form-check-label" htmlFor="waiverFixed" > Fixed Amount </label>

              </div>

            </div>
          </Col>

          <Col>
            <div className="d-flex justify-content-end gap-2 flex-wrap">

              <button type="button" className="btn btn-primary"
                style={{ width: "135px" }} onClick={handleNew}
                disabled={isEditable} > New </button>

              <button type="button" className="btn btn-warning" style={{ width: "135px" }} 
                disabled={isEditable} onClick={(e) => (setShowSearchModal(true))} > Edit </button>
              {showsearchModal && (
                <EditFeeWaiverModal
                  show={showsearchModal}
                  handleClose={() => setShowSearchModal(false)}
                  onRowSelect={handleSelectedRow} />
              )}

              <button type="button" className="btn btn-secondary" disabled={!isEditable}
                style={{ width: "135px" }} onClick={handleClear} > Clear </button>

              <button type="button" className="btn btn-success"
                style={{ width: "135px" }} onClick={handleSave}
                disabled={!isEditable} > Save </button>
            </div>

          </Col>

        </Row>


      </Card>

      {/* Child Table */}
      <Card className="p-3">
        {/* <h5>Maintenance Items</h5> */}
        <div style={{ minHeight: '220px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">
            <thead>
              <tr>
                <th style={{ width: '4%', textAlign: 'center' }}>#</th>
                <th style={{ width: '25%', textAlign: 'left' }}>Fee Description</th>
                <th style={{ width: '9%', textAlign: 'left' }}>Fee Waiver % </th>
                <th style={{ width: '9%', textAlign: 'right' }}>Installment-1</th>
                <th style={{ width: '9%', textAlign: 'right' }}>Installment-2</th>
                <th style={{ width: '9%', textAlign: 'right' }}>Installment-3</th>
                <th style={{ width: '9%', textAlign: 'right' }}>Installment-4</th>
                <th style={{ width: '9%', textAlign: 'right' }}>Installment-5</th>
                <th style={{ width: '9%', textAlign: 'right' }}>Installment-6</th>
                <th style={{ width: '5%', textAlign: 'right' }}></th>
              </tr>
            </thead>

            <tbody>
              {childRows.map((row, index) => (
                <tr key={index}>
                  <td style={{ width: "5%", textAlign: 'center' }}>{index + 1}</td>
                  <td>
                    <Select name="fee_code"
                      inputId={`fee_code_${index}`} classNamePrefix="react-select"
                      className={rowErrors[index]?.field === 'fee_code' ? 'react-select-error' : ''}
                      options={feesDescOptions}
                      value={feesDescOptions.find(option => String(option.value) === String(row.fee_code)) || null}
                      onChange={(selectedOption) => handleFeesCodeChange(index, selectedOption)}
                      isDisabled={!isEditable}
                      placeholder="-- Select Fees Description --"
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} />
                  </td>

                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      className={`form-control ${rowErrors[index]?.field === 'fw_perc' ? 'is-invalid' : ''}`}
                      type="number" name="fw_perc" value={row.fw_perc} 
                      // onBlur={(e) => handleBlurFWPerc(index, e)}
                      min="0" max="0" onChange={(e) => handleChildChange(index, e)} />
                  </td>

                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      className={`form-control ${rowErrors[index]?.field?.includes('fw_inst1') ? 'is-invalid' : ''}`}
                      type="decimal" name="fw_inst1" value={row.fw_inst1} onChange={(e) => handleChildChange(index, e)} />
                  </td>

                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      className={`form-control ${rowErrors[index]?.field?.includes('fw_inst2') ? 'is-invalid' : ''}`}
                      type="decimal" name="fw_inst2" value={row.fw_inst2} onChange={(e) => handleChildChange(index, e)} />
                  </td>

                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      className={`form-control ${rowErrors[index]?.field?.includes('fw_inst3') ? 'is-invalid' : ''}`}
                      type="decimal" name="fw_inst3" value={row.fw_inst3} onChange={(e) => handleChildChange(index, e)} />
                  </td>

                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      className={`form-control ${rowErrors[index]?.field?.includes('fw_inst4') ? 'is-invalid' : ''}`}
                      type="decimal" name="fw_inst4" value={row.fw_inst4} onChange={(e) => handleChildChange(index, e)} />
                  </td>

                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      className={`form-control ${rowErrors[index]?.field?.includes('fw_inst5') ? 'is-invalid' : ''}`}
                      type="decimal" name="fw_inst5" value={row.fw_inst5} onChange={(e) => handleChildChange(index, e)} />
                  </td>

                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      className={`form-control ${rowErrors[index]?.field?.includes('fw_inst6') ? 'is-invalid' : ''}`}
                      type="decimal" name="fw_inst6" value={row.fw_inst6} onChange={(e) => handleChildChange(index, e)} />
                  </td>

                  <td style={{ textAlign: 'center' }}>
                    {childRows.length > 1 && (
                      <Button variant="danger" onClick={() => removeRow(index)} size="sm">Delete</Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* <div className="mb-3">
          <Button disabled={!isEditable} style={{ marginTop: '10px' }} variant="primary" onClick={addRow}>Add Row</Button>
        </div> */}

        <div className="d-flex justify-content-end mt-2">
          <OverlayTrigger placement="bottom"
            overlay={<Tooltip id="add-tooltip" style={{ backgroundColor: "#e9ecef" }}>Add Row</Tooltip>}>
            <Button variant="primary" onClick={addRow}  disabled={!isEditable}
              style={{ width: "45px", height: "45px", borderRadius: "50%", padding: "0", fontSize: "30px" }}> +
            </Button>
          </OverlayTrigger>
        </div>

      </Card>

      {/* Buttons */}
    </Container>
  );
};

export default FeeWaiver;
